export default __webpack_public_path__ + "static/icon-6-6-9a7cbc8baecaae93a9c5a48a26ea728b.png";